/** * @author ❤️❤️❤️ FightFastest 🤎🤎🤎 * @date 🚙 🚒 🛺 10/3/2022 上午 10:50 下午 1:57 🚌🚄🚈🚝 */

<template>
	<el-container>
		<el-radio-group v-model="equip" size="medium" @change="equipStateChange" style="margin:0 10px 10px">
			<el-radio-button :label="true">未标定</el-radio-button>
			<el-radio-button :label="false">已标定</el-radio-button>
		</el-radio-group>
		<el-container>
			<el-main>
				<el-card class="radio-style" shadow="always" style="padding-bottom: 10px">
					<div class="radio-wrap">
						<el-radio
							v-show="equip"
							style="display: block;line-height: 30px"
							v-model="questionId"
							:label="item.pkId"
							v-for="item in unQusList"
							:key="item.pkId"
						>
							{{ `${item.titleNumber}` }}
						</el-radio>
						<el-table
							v-show="!equip"
							ref="multipleTable"
							:data="pointedList"
							tooltip-effect="dark"
							height="340"
							style="width: 100%;margin-top: 5px"
							border
							strip
							@selection-change="handleSelectionPointedList"
						>
							<el-table-column type="selection" width="55"> </el-table-column>
							<el-table-column prop="className" label="班级"> </el-table-column>
							<el-table-column prop="questionName" label="题号"> </el-table-column>
							<el-table-column prop="knowledgeName" label="知识点"> </el-table-column>
							<el-table-column prop="avgScore" label="班级平均分"> </el-table-column>
							<el-table-column prop="customizeAvgScore" label="自定义平均分"> </el-table-column>
							<el-table-column label="操作">
								<template slot-scope="scope">
									<el-popover placement="right" width="400" trigger="click">
										<div style="display: flex;justify-content: flex-start">
											<el-input placeholder="请输入自定义分数" v-model="scope.row.customizeAvgScore" size="medium"></el-input>
											<el-button type="primary" size="medium" style="margin-left: 10px" @click="handleCustomAvg(scope.row)">
												确定
											</el-button>
										</div>
										<el-button type="text" size="small" slot="reference">修改自定义平均分</el-button>
									</el-popover>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</el-card>
			</el-main>
			<el-aside v-show="equip" width="500px">
				<el-card shadow="always" class="tree-style">
					<el-input placeholder="输入关键字进行过滤" v-model="treeFileText"></el-input>
					<el-tree
						style="max-height: 238px;overflow: auto"
						:props="defaultProps"
						:data="knowledgeInfo"
						show-checkbox
						ref="tree"
						node-key="pkId"
						:filter-node-method="filterNode"
						@check-change="handleCheckChange"
					>
					</el-tree>
					<div class="tree-tag">
						<el-tag v-for="tag in knowledgeName" :key="tag.pkId" @close="delTag(tag)" size="medium" closable type="success" class="tag">
							{{ tag.name }}
						</el-tag>
					</div>
				</el-card>
			</el-aside>
		</el-container>
		<el-footer class="footer-style">
			<el-button plain @click="quit"> 取 消 </el-button>
			<el-button type="primary" @click="confirm" v-if="equip"> 确 定 </el-button>
			<el-button type="danger" @click="del" v-else> 删 除 </el-button>
		</el-footer>
	</el-container>
</template>

<script>
export default {
	name: 'temp',
	props: {
		knowledgeBasicInfo: {
			type: Object,
			default: () => {}
		}
	},
	watch: {
		treeFileText(val) {
			this.$refs.tree.filter(val)
		}
	},
	data() {
		return {
			knowledgeInfo: [],
			pointedList: [],
			treeFileText: '',
			defaultProps: {
				children: 'children',
				label: 'name'
			},
			unQusList: [],
			knowledgeId: [],
			knowledgeName: [],
			questionId: '',
			conifgList: [],
			equip: true,
			query: this.$route.query
		}
	},
	created() {
		this.noEquip()
	},
	methods: {
		//过滤
		filterNode(value, data) {
			if (!value) return true
			return data.name.indexOf(value) !== -1
		},
		// 选择知识点
		handleCheckChange(data, checked) {
			if (checked) {
				this.knowledgeId.push(data.pkId)
				this.knowledgeName.push({ name: data.name, pkId: data.pkId })
			} else {
				let index = this.knowledgeId.indexOf(data.pkId)
				this.$delete(this.knowledgeId, index)
				let delName = this.knowledgeName.filter(res => res.pkId !== data.pkId)
				this.knowledgeName = delName
			}
		},
		// 已标定
		hasEquip() {
			const params = { examId: this.query.examId, ...this.knowledgeBasicInfo }
			this.$post('knowledgeSubjectConfig/queryKnowledgeConfigList', params).then(res => {
				console.log(res.data)
				this.pointedList = res.data
			})
		},

		//没有标定
		noEquip() {
			const params = { examId: this.query.examId, ...this.knowledgeBasicInfo }
			this.$post('knowledgeSubjectConfig/queryKnowledgeAndQuestionInfo', params).then(res => {
				let knowledgeInfo = this.arrayToTree(res.data.knowledgeInfo, '0')
				this.knowledgeInfo = knowledgeInfo
				this.unQusList = res.data.questionInfo
			})
		},
		arrayToTree(arr, parentId) {
			return arr.reduce((acc, cur) => {
				if (cur['parentId'] === parentId) {
					cur.children = this.arrayToTree(arr, cur['pkId'])
					return acc.concat(cur)
				}
				return acc
			}, [])
		},
		//切换标定状态
		equipStateChange(val) {
			if (val) {
				this.noEquip()
			} else {
				this.hasEquip()
			}
		},
		// 确定
		confirm() {
			const params = {
				examId: this.query.examId,
				...this.knowledgeBasicInfo,
				questionId: this.questionId,
				knowledgeId: this.knowledgeId.join(',')
			}
			this.$post('knowledgeSubjectConfig/saveKnowledgeAndQuestion', params).then(res => {
				if (res.code === '200') {
					this.$message.success('标定成功')
					this.$refs.tree.setCheckedKeys([])
					this.noEquip()
				}
			})
		},
		// 已编辑 删除
		del() {
			const params = {
				examId: this.query.examId,
				configId: this.conifgList.join(',')
			}
			this.$post('knowledgeSubjectConfig/deleteKnowledgeConfig', params).then(res => {
				if (res.code === '200') {
					this.$message.success('删除成功')
					this.hasEquip()
				}
			})
		},
		// 取消
		quit() {
			this.$emit('input', false)
		},
		// 已编辑  选择
		handleSelectionPointedList(val) {
			let conifgList = []
			val.forEach(res => conifgList.push(res.pkId))
			this.conifgList = conifgList
		},
		// 已编辑 修改自定义分数
		handleCustomAvg(val) {
			const params = {
				examId: this.query.examId,
				configId: val.pkId,
				avgScore: val.customizeAvgScore
			}
			this.$post('knowledgeSubjectConfig/updateKnowledgeConfigAvg', params).then(res => {
				if (res.code === '200') {
					this.$message.success('修改成功')
					this.hasEquip()
				}
			})
		},
		// TAG 删除
		delTag(val) {
			let index = this.knowledgeId.indexOf(val.pkId)
			this.$delete(this.knowledgeId, index)
			this.$refs.tree.setCheckedKeys(this.knowledgeId)
		}
	}
}
</script>

<style scoped lang="less">
.radio-style {
	display: block;
	height: 350px;
}
.radio-wrap {
	height: 350px;
	overflow: auto;
}
.tree-style {
	display: block;
	height: 350px;
	overflow: auto;
	margin-left: 20px;
	position: relative;
	padding-bottom: 10px;
}
.el-main {
	padding: 0 0 0 10px;
	box-sizing: border-box;
}
.footer-style {
	display: flex;
	justify-content: center;
	align-items: flex-end;
}
.tree-tag {
	margin-right: 5px;
	position: absolute;
	bottom: 5px;
	left: 5px;
	.tag {
		margin-right: 5px;
	}
}
/deep/.el-card__body {
	padding: 10px;
}
</style>
